import Sidebar from '../envelope/Sidebar';
import TopBar from '../envelope/TopBar';
import GroupCard from './GroupCard';
import TestCard from './TestCard';
import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import './CreateTestingPage.css';
import { useNavigate } from 'react-router-dom';

const CreateTestingPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [groups, setGroups] = useState([]);
  const [testPatterns, setTestPatterns] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedTestPattern, setSelectedTestPattern] = useState(null);
  const [userCompanyId, setUserCompanyId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const navigate = useNavigate();

  // Загрузка групп
  const fetchGroups = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('http://185.250.149.189:8000/api/v1/GroupUsers', {
        headers: {
          'Authorization': `Token ${token}`,
        }
      });
      
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      
      const data = await response.json();
      
      
      // Извлекаем группы из ответа
      let groupsArray = [];
      if (Array.isArray(data)) {
        groupsArray = data;
      } 
      else if (data.groups_users && Array.isArray(data.groups_users)) {
        groupsArray = data.groups_users;
      }
      else if (data.groups && Array.isArray(data.groups)) {
        groupsArray = data.groups;
      }
      else if (data.results && Array.isArray(data.results)) {
        groupsArray = data.results;
      }
      
      return groupsArray;
      
    } catch (error) {
      console.error('Ошибка загрузки групп:', error);
      setError('Не удалось загрузить группы');
      return [];
    }
  };

  // Загрузка шаблонов тестов
  const fetchTestPatterns = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('http://185.250.149.189:8000/api/v1/TestPatterns', {
        headers: {
          'Authorization': `Token ${token}`,
        }
      });
      
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      
      const data = await response.json();
      return data.patterns || [];
      
    } catch (error) {
      console.error('Ошибка загрузки шаблонов:', error);
      setError('Не удалось загрузить шаблоны тестов');
      return [];
    }
  };

  // Загрузка ID компании пользователя
  const fetchUserCompanyId = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('http://185.250.149.189:8000/api/v1/Company', {
        headers: {
          'Authorization': `Token ${token}`,
        }
      });
      
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
      
      const data = await response.json();
      return data.Company?.id || null;
      
    } catch (error) {
      console.error('Ошибка загрузки компании:', error);
      return null;
    }
  };

  // Загрузка всех данных
  useEffect(() => {
    const loadData = async () => {
      setIsDataLoading(true);
      try {
        // Загружаем данные параллельно
        const [companyId, groupsData, patternsData] = await Promise.all([
          fetchUserCompanyId(),
          fetchGroups(),
          fetchTestPatterns()
        ]);
        
        setUserCompanyId(companyId);
        setGroups(groupsData);
        setTestPatterns(patternsData);
        
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
        setError('Не удалось загрузить данные');
      } finally {
        setIsDataLoading(false);
      }
    };
    
    loadData();
  }, []);

  // Фильтрация данных по company_id
  const filteredGroups = userCompanyId === 1 
    ? groups 
    : groups.filter(group => group.company_id === userCompanyId);

  const filteredTestPatterns = userCompanyId === 1 
    ? testPatterns 
    : testPatterns.filter(pattern => pattern.company_id === userCompanyId);

  const handleCreateTesting = async () => {
    if (!selectedGroup || !selectedTestPattern) {
      alert('Выберите группу и шаблон теста!');
      return;
    }

    if (!name.trim()) {
      alert('Введите название тестирования');
      return;
    }

    // Проверяем наличие социометрических вопросов
    const hasSociometry = selectedTestPattern.questions.some(
      q => q.quest_type === 'sociometry'
    );
    
    // Определяем тип социометрии
    let sociometryType = '';
    if (hasSociometry) {
      sociometryType = selectedTestPattern.is_param 
        ? "параметрическое" 
        : "непараметрическое";
    }

    // Формируем финальное описание
    let finalDescription = description;
    if (hasSociometry) {
      if (finalDescription) {
        finalDescription += '\n\n'; // Добавляем отступ, если описание не пустое
      }
      finalDescription += `Тип социометрического исследования: ${sociometryType}.`;
    }

    const testingData = {
      name: name.trim(),
      description: finalDescription.trim(), // Используем финальное описание
      is_param: true,
      questions: selectedTestPattern.questions.map(q => ({
        id: q.id,
        title: q.title,
        quest_type: q.quest_type,
        data: q.data
      })),
      company_id: userCompanyId,
      group_id: selectedGroup.id
    };

    try {
      setIsLoading(true);
      setError(null);
      setSuccess(false);
      
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('Токен авторизации не найден');
      }
      
      const response = await fetch('http://185.250.149.189:8000/api/v1/Test/', {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(testingData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Ошибка HTTP: ${response.status}`);
      }
      
      const responseData = await response.json();
      setSuccess(true);
      
      const creationData = {
        testId: responseData.test.id,
        name,
        description,
        selectedGroup,
        selectedTestPattern
      };

      navigate('/createlink', { state: creationData });
      
    } catch (error) {
      console.error('Ошибка при создании тестирования:', error);
      setError(error.message || 'Произошла ошибка при создании тестирования');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <TopBar isCollapsed={isSidebarCollapsed} />  
      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="content-container">
          <h1>Создать тестирование</h1>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          {success && (
            <div className="success-message">
              Тестирование успешно создано!
            </div>
          )}

          {isDataLoading ? (
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <p>Загрузка данных...</p>
            </div>
          ) : (
            <>
              <div className="TestPatternDescription"> 
                <div className="TestName">
                  Название теста 
                  <textarea 
                    className='input1' 
                    name="test_name" 
                    placeholder="Введите название теста"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={isLoading}
                  ></textarea>
                </div>
                <div className="TestDes">
                  Описание теста
                  <textarea 
                    className='input2' 
                    name="test_Des" 
                    placeholder="Опишите тест"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled={isLoading}
                  ></textarea>
                </div>
              </div>

              <div className='ActiveSelect'>
                <div className="selection-container">
                  {/* Секция выбора группы */}
                  <div className="selection-column">
                    <h2>Шаг 2. Выберите группу</h2>
                    {filteredGroups.length === 0 ? (
                      <div className="no-data-message">
                        {userCompanyId === 1
                          ? 'Группы не найдены'
                          : 'Для вашей компании группы не найдены'
                        }
                      </div>
                    ) : (
                      <div className="group-cards-container">
                        {filteredGroups.map(group => (
                          <GroupCard
                            key={group.id}
                            group={group}
                            isSelected={selectedGroup?.id === group.id}
                            onClick={() => !isLoading && setSelectedGroup(group)}
                            disabled={isLoading}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                  
                  {/* Секция выбора шаблона теста */}
                  <div className="selection-column">
                    <h2>Шаг 3. Выберите тест</h2>
                    {filteredTestPatterns.length === 0 ? (
                      <div className="no-data-message">
                        {userCompanyId === 1
                          ? 'Шаблоны тестов не найдены'
                          : 'Для вашей компании шаблоны тестов не найдены'
                        }
                      </div>
                    ) : (
                      <div className="test-cards-container">
                        {filteredTestPatterns.map(pattern => (
                          <TestCard
                            key={pattern.id}
                            test={pattern}
                            isSelected={selectedTestPattern?.id === pattern.id}
                            onClick={() => !isLoading && setSelectedTestPattern(pattern)}
                            disabled={isLoading}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              <div className='SaveActive'>
                <button 
                  className="add-button" 
                  onClick={handleCreateTesting}
                  disabled={isLoading || !selectedGroup || !selectedTestPattern}
                >
                  {isLoading ? 'Создание...' : 'Создать тестирование'}
                </button>
              </div>
            </>
          )}
        </div>
      </main>
    </div>
  );
};

export default CreateTestingPage;